/**
 * This is the settings on a Guest Invite feature
 */

export enum GuestInviteCompanyFieldRequirementEnum {
  Hide = 'hide',
  Optional = 'optional',
  Required = 'required',
}

export type GuestInviteFeatureProperties = {
  showLaneUsers: boolean;
  minGuests: number;
  maxGuests: number;
  companyFieldRequirement?: GuestInviteCompanyFieldRequirementEnum;
};
